import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isNavigationOpenSelector } from '../../../redux/reducers/ui/modals';
import { hideNavigationModal } from '../../../redux/actions/ui/modals';

export const useModalOpen = () => {
  const dispatch = useDispatch();
  const { key } = useLocation();
  const isOpen = useSelector(isNavigationOpenSelector);

  useEffect(() => {
    dispatch(hideNavigationModal());
  }, [dispatch, key]);

  return isOpen;
};
